import { DialogContentText } from "@material-ui/core";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface CornermarkDeleteDialgProps {
  confirmButtonState: ConfirmButtonTransitionState;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
}
const CornermarkDeleteDialg: React.FC<CornermarkDeleteDialgProps> = ({
  title,
  confirmButtonState,
  onClose,
  onConfirm,
  open
}) => {
  const intl = useIntl();
  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      confirmButtonState={confirmButtonState}
      onConfirm={onConfirm}
      variant="delete"
      title={intl.formatMessage({
        defaultMessage: "Delete cornermark",
        description: "dialog title"
      })}
    >
      <DialogContentText>
        <FormattedMessage
          defaultMessage="Are you sure you want to delete {cornermark}?"
          description="dialog content"
          values={{
            cornermark: <strong>{title}</strong>
          }}
        />
      </DialogContentText>
    </ActionDialog>
  );
};
export default CornermarkDeleteDialg;
